import { adminMenu, anonMenu, customerMenu,  workerMenu } from "./constants";

import AnonymousMain from "@/components/templates/Main/AnonymousMain";
import { Box } from "@/components/atoms";
import { Main } from "#/templates";
import { useApi } from "@/api";
import { useNavigate } from "react-router-dom";

const OptionalAuth = ({ children }: { children: JSX.Element }) => {
  const { session /*, support*/ } = useApi();
  // const { showModal, onCloseModal, onOpenModal } = useModal();
  const navigate = useNavigate();

  const handleEditProfile = () => {
    if (session?.user)
      navigate(session.user.worker ? '/account-worker' : '/account-customer')
  }

  return (<>
    { session.isLoggedIn() && session.user ?
    <Main
      user={{
        firstName: session.user.firstName,
        lastName: session.user.lastName,
      }}
      navigation={{
        menus: session.user.admin ? adminMenu : ( session.user.worker ? workerMenu : customerMenu),
        onLogout: session.logout
      }}
      onEditProfile={handleEditProfile}
    >
      <Box margin="50px 0 0px">
        {children}
      </Box>
    </Main> : <AnonymousMain navigation={ { menus: anonMenu, onLogout: () => { session.logout();  } } }
    >
         <Box margin="50px 0 0px">
        {children}
      </Box>
      </AnonymousMain> }
    </>
  );
}

export default OptionalAuth;
